import { render, staticRenderFns } from "./comboDetail.vue?vue&type=template&id=5b1b176e&scoped=true&"
import script from "./comboDetail.vue?vue&type=script&lang=js&"
export * from "./comboDetail.vue?vue&type=script&lang=js&"
import style0 from "./comboDetail.vue?vue&type=style&index=0&id=5b1b176e&lang=scss&scoped=true&"
import style1 from "./comboDetail.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b1b176e",
  null
  
)

export default component.exports